export const SET_ACTIVE_INGREDIENT_CATEGORY_ID = 'SET_ACTIVE_INGREDIENT_CATEGORY_ID';

export const setActiveIngredientCategoryId = ({ ingredientCategoryId }) => ({
  type: SET_ACTIVE_INGREDIENT_CATEGORY_ID,
  ingredientCategoryId,
});
